import React from 'react';

const WaitlistSubmissionsIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_14479_75335)'>
        <path
          d='M8.0026 1.33398V4.00065M10.8026 5.20065L12.7359 3.26732M12.0026 8.00065H14.6693M10.8026 10.8007L12.7359 12.734M8.0026 12.0007V14.6673M3.26927 12.734L5.2026 10.8007M1.33594 8.00065H4.0026M3.26927 3.26732L5.2026 5.20065'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_14479_75335'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WaitlistSubmissionsIcon;
